import axios from 'axios';
import { AppAlert } from './index'
// export var BaseUrl = "http://192.168.1.39:3031/api";
export var BaseUrl = "http://shabakehafzar.net:3031/api";

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data.
    // console.log(navigationRef)
    return response

}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response !== undefined)
        if (error.response.status === 401) {
            if (localStorage.getItem('accessToken') !== null) {
                localStorage.clear();
                AppAlert(401, error.response.data)
                setTimeout(() => {
                    window.location.assign('/')
                }, 3000);
            }

        }


    return Promise.reject(error);
});

export async function ajax(sys, url, Method, isbody, body) {

    let localUrl = BaseUrl + url;
    // let localUrl = url;
    var token = localStorage.getItem('accessToken');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    switch (sys) {
        case 'tokenFormData':
            return await axios({
                method: Method,
                url: localUrl,
                data: isbody ? body : null,
                headers: { 'Content-Type': 'multipart/form-data' }
            });

        case 'tokenJson':
            return (
                await axios({
                    url: localUrl,
                    method: Method,
                    data: isbody ? JSON.stringify(body) : null,
                    //  timeout: 60 * 1 * 1000, // Let's say you want to wait at least 1 mins

                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    },

                })
            );
        case 'excelDownload':
            return (
                await axios({
                    url: localUrl,
                    method: Method,
                    data: isbody ? JSON.stringify(body) : null,
                    headers: {
                        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    },
                    responseType: 'arraybuffer',
                })
            );

        case 'TokenUrl':
            return await axios({
                url: localUrl + body,
                method: Method,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            });
        case 'Url':
            function checkbody(localUrl, body) {
                if (typeof (body) === 'undefined') {
                    return localUrl
                } else {
                    return localUrl + body
                }
            }
            return await axios({
                url: checkbody(localUrl, body),
                method: Method,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            });
        case 'FormData':
            return await axios({
                method: Method,
                url: localUrl,
                data: isbody ? body : null,
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        default:
            return (
                await axios({
                    url: localUrl,
                    method: Method,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    data: isbody ? JSON.stringify(body) : null
                })
            )
    }
}

